/* tslint:disable */

declare var Object: any;
export interface ERPfinanceInterface {
  "id"?: number;
}

export class ERPfinance implements ERPfinanceInterface {
  "id": number;
  constructor(data?: ERPfinanceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPfinance`.
   */
  public static getModelName() {
    return "ERPfinance";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPfinance for dynamic purposes.
  **/
  public static factory(data: ERPfinanceInterface): ERPfinance{
    return new ERPfinance(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPfinance',
      plural: 'ERPfinances',
      path: 'ERPfinances',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPfinance.ts